import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { AuthServicesService } from 'src/app/auth/services/auth-services.service';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../services/utils.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss','./footer.component.rtl.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class FooterComponent implements OnInit {
  appVersion: any;
  currentDate: any;
  @Output() openStaticPrivacyPolicy = new EventEmitter();
  locale: any;
  constructor(
    public translate: TranslateService,
    private ccService: NgcCookieConsentService,
    private store: Store,
    public util: UtilsService,
    private authService: AuthServicesService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.store
      .select((state) => state)
      .subscribe((data: any) => {
        this.locale = data?.authReducer?.localLanguage?.locale;
      });
    this.appVersion = environment.HEROKU_RELEASE_VERSION;
    console.log(this.appVersion);
    moment.locale(this.locale);
    let date = new Date();
    this.currentDate = moment(date).format('YYYY');
  }

  onCookiePolicyClicked() {
    this.ccService.open();
  }

  onPrivacyPolicyClicked() {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['settings', 'privacy-policy']);
    } else {
      this.openStaticPrivacyPolicy.emit('openPrivacyPolicy');
    }
  }
}
